import './common/_commonjsHelpers-8c19dec8.js';
import './common/index-e926b5b9.js';
import { r as reactDom } from './common/index-07c610e6.js';



var render = reactDom.render;
export { render };
